const openPushMenu = () => {
    return {
        type: "OPEN_PUSH_MENU",
        payload: {}
    }
};

const closePushMenu = () => {
    return {
        type: "CLOSE_PUSH_MENU",
        payload: {}
    }
};

export {openPushMenu, closePushMenu};


// WEBPACK FOOTER //
// ./src/actions/PushMenu.js